import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { saveState, loadState, removeState } from '../../utils/browser-storage';

const type = 'token';

interface TokenState {
  token: string;
}

const initialState: TokenState = {
  token: loadState<string>(type) ?? ''
};

export const tokenSlice = createSlice({
  name: type,
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      saveState(type, action.payload);
    },
    removeToken: (state) => {
      state.token = '';
      removeState(type);
    }
  }
});

export const { setToken, removeToken } = tokenSlice.actions;

export default tokenSlice.reducer;
